/* eslint-disable formatjs/no-literal-string-in-jsx */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable arrow-body-style */
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { baseStyles, tableStyles } from './styles';

const styles = {
  scoreSummary: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: '16px',
    marginBottom: '24px',
  },
  scoreLabel: {
    fontSize: '14px',
    marginBottom: '8px',
  },
  scoreValue: {
    fontSize: '24px',
    fontWeight: '700',
  },
  scoreChange: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#007e33',
    backgroundColor: '#dff7e7',
    borderRadius: '12px',
    padding: '4px 8px',
    marginLeft: '8px',
  },
};

const getChangeStyle = percent => {
  if (percent >= 0)
    return { color: '#0A522E', backgroundColor: '#E0F1E9', symbol: '↑' };
  if (percent < 0)
    return { color: '#8B091A', backgroundColor: '#F2E6E8', symbol: '↓' };
};

const AssessmentSummary = props => {
  const { intl, current_ors, previous_ors } = props;

  const orsMessages = {
    Individual: {
      title: intl.formatMessage({ defaultMessage: 'Individually' }),
      description: intl.formatMessage({
        defaultMessage: 'Personal well-being',
      }),
    },
    Interpersonal: {
      title: intl.formatMessage({ defaultMessage: 'Interpersonally' }),
      description: intl.formatMessage({
        defaultMessage: 'Family, close relationships',
      }),
    },
    Social: {
      title: intl.formatMessage({ defaultMessage: 'Socially' }),
      description: intl.formatMessage({
        defaultMessage: 'Work, School, Friendships',
      }),
    },
    Overall: {
      title: intl.formatMessage({ defaultMessage: 'Overall' }),
      description: intl.formatMessage({
        defaultMessage: 'General sense of well-being',
      }),
    },
    // Couples ORS
    Trust: {
      title: intl.formatMessage({ defaultMessage: 'Trust' }),
      description: intl.formatMessage({
        defaultMessage: 'How much trust has there been in your relationship?',
      }),
    },
    Conflict: {
      title: intl.formatMessage({ defaultMessage: 'Conflict' }),
      description: intl.formatMessage({
        defaultMessage:
          'How well has conflict been dealt with in your relationship?',
      }),
    },
    Values: {
      title: intl.formatMessage({ defaultMessage: 'Values' }),
      description: intl.formatMessage({
        defaultMessage:
          'How well have your values and goals aligned with your partner?',
      }),
    },
    Happiness: {
      title: intl.formatMessage({ defaultMessage: 'Happiness' }),
      description: intl.formatMessage({
        defaultMessage: 'How happy have you been in your relationship?',
      }),
    },
  };

  const totalCurrent = current_ors.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );
  const totalPrevious = previous_ors.reduce(
    (sum, item) => sum + (item.score || 0),
    0,
  );

  const changePercent =
    totalPrevious === 0
      ? 0
      : ((totalCurrent - totalPrevious) / totalPrevious) * 100;

  const { color, backgroundColor, symbol } = getChangeStyle(changePercent);
  const roundedChange = Math.abs(Math.round(changePercent));

  return (
    <div style={baseStyles.card}>
      <div style={baseStyles.sectionTitle}>
        {intl.formatMessage({ defaultMessage: 'Summary' })}
      </div>
      <div style={styles.scoreSummary}>
        <div>
          <div style={{ ...styles.scoreLabel, color: '#666' }}>
            {intl.formatMessage({ defaultMessage: 'Total Score (Today)' })}
          </div>
          <div style={styles.scoreValue}>
            {totalCurrent}/40
            <span style={{ ...styles.scoreChange, color, backgroundColor }}>
              {symbol} {roundedChange}%
            </span>
          </div>
        </div>
        <div
          style={{
            width: '1px',
            backgroundColor: '#eee',
            alignSelf: 'stretch',
          }}
        ></div>
        <div>
          <div style={{ ...styles.scoreLabel, color: '#888' }}>
            {intl.formatMessage({
              defaultMessage: 'Total Score (Last Session)',
            })}
          </div>
          <div style={{ ...styles.scoreValue, color: '#888' }}>
            {totalPrevious}/40
          </div>
        </div>
      </div>
      <div style={baseStyles.sectionTitle}>
        {intl.formatMessage({ defaultMessage: 'Breakdown' })}
      </div>
      <table style={tableStyles.table}>
        <thead>
          <tr>
            <th style={tableStyles.th}>
              {intl.formatMessage({ defaultMessage: 'Domain(s)' })}
            </th>
            <th style={tableStyles.th}>
              {intl.formatMessage({ defaultMessage: 'Score (Today)' })}
            </th>
            <th style={{ ...tableStyles.th, fontWeight: 600 }}>
              {intl.formatMessage({ defaultMessage: 'Score (Last session)' })}
            </th>
          </tr>
        </thead>
        <tbody>
          {current_ors.map((current, idx) => {
            const previous = previous_ors.find(p => p.name === current.name);
            const meta = orsMessages[current.name] || {
              title: current.name,
              description: '',
            };

            return (
              <tr key={current.name}>
                <td style={tableStyles.td}>
                  <div style={{ fontWeight: 600 }}>{`${idx + 1}. ${
                    meta.title
                  }`}</div>
                  <div style={styles.subtitle}>{meta.description}</div>
                </td>
                <td style={tableStyles.td}>
                  <strong>
                    {current.score === null ? '-' : `${current.score}/10`}
                  </strong>
                </td>
                <td style={tableStyles.td}>
                  {previous.score === null ? '-' : `${previous.score}/10`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

AssessmentSummary.propTypes = {
  intl: PropTypes.object.isRequired,
  current_ors: PropTypes.arrayOf(
    PropTypes.shape({
      score: PropTypes.number,
    }),
  ).isRequired,
  previous_ors: PropTypes.arrayOf(
    PropTypes.shape({
      score: PropTypes.number,
    }),
  ).isRequired,
};

export default injectIntl(AssessmentSummary);
